import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { useMarkCompleteV3 } from 'hooks/useMarkCompleteV3'

import {
  resolveTrainingCourseNodeId,
  resolveTrainingCoursePointer,
} from './trainingHelpers'
import { UnitV3TrainingCardComponent } from './component'

export function UnitV3TrainingCardContainer({
  trainingLinkSummary,
  contentGroupCode,
  instructorDataKey,
  siteId,
  isPreview,
  path,
  title,
  description,
}) {
  const { coursePointer, courseNodeId } = useMemo(
    () => ({
      coursePointer: resolveTrainingCoursePointer({
        trainingLinkSummary,
        contentGroupCode,
      }),
      courseNodeId: resolveTrainingCourseNodeId(trainingLinkSummary),
    }),
    [trainingLinkSummary, contentGroupCode],
  )

  const shouldResolveCompletion =
    !isPreview &&
    !!instructorDataKey &&
    !!contentGroupCode &&
    !!coursePointer &&
    !!courseNodeId

  const { isComplete } = useMarkCompleteV3({
    coursePointer: shouldResolveCompletion ? coursePointer : null,
    courseNodeId: shouldResolveCompletion ? courseNodeId : null,
    contentGroupCode: shouldResolveCompletion ? contentGroupCode : null,
    instructorDataKey: shouldResolveCompletion ? instructorDataKey : null,
    siteId,
  })

  return (
    <UnitV3TrainingCardComponent
      description={description}
      isPreview={isPreview}
      markedComplete={shouldResolveCompletion ? isComplete : false}
      path={path}
      title={title}
    />
  )
}

UnitV3TrainingCardContainer.propTypes = {
  contentGroupCode: PropTypes.string,
  description: PropTypes.string,
  instructorDataKey: PropTypes.string,
  isPreview: PropTypes.bool,
  path: PropTypes.string.isRequired,
  siteId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string,
  trainingLinkSummary: PropTypes.object,
}
